const quoteData = {
  meta: {
    title: "MTS Digital Commerce & Custom Cabinetry Platform Proposal",
    clientName: "MTS",
    contactName: "",
    date: "2026-07-17",
    quoteNumber: "Q-2026-MTS-DIGITAL-PLATFORM",
    preparedBy: "Jason Toomer",
    summary: [
      "Hi Marsin and gabby",
      "Thank you for the opportunity to prepare this proposal for the continued digital expansion of MTS.",
      "",
      "This proposal is divided into two separate project areas.",
      "",
      "The first project covers the integration of a complete Shopify-powered e-commerce platform into the existing MTS React website. This approach retains the current website, protects its established traffic and search authority, and introduces a scalable online shop for bathroom products, tapware, replacement parts, accessories, and related product ranges.",
      "",
      "The e-commerce platform will initially support up to 150 products, with the capability to expand to thousands of products and multiple suppliers. Products may be held directly by MTS or fulfilled through supplier and drop-shipping arrangements.",
      "",
      "The second project covers the development of a dedicated Custom Cabinetry digital experience within the existing MTS website. This area will operate as a distinct customer journey while benefiting from the authority, analytics, infrastructure, and traffic of the existing domain.",
      "",
      "Two Custom Cabinetry implementation options are provided:",
      "",
      "1. A Cabinetry MVP featuring a dedicated brochure and lead-generation experience, an interactive room layout tool, configurable cabinet products, indicative pricing, and design enquiry submission.",
      "",
      "2. A Premium Cabinetry Planner providing a more advanced IKEA-style three-dimensional room and cabinet planning experience with enhanced configuration, visualisation, pricing, saved designs, and sales workflow features.",
      "",
      "The e-commerce shop and Custom Cabinetry service will use one Google Ads account with separate campaigns, conversion goals, budgets, landing pages, and performance reporting for each business area.",
      "",
      "Regards,",
      "Jason"
    ]
  },

  business: {
    name: "2merative",
    abn: "61775724636",
    email: "hello@2merative.com",
    phone: "0498 135 744"
  },

  options: [
    {
      id: "mts-ecommerce-platform",
      label: "MTS E-Commerce Platform – Existing React Website Integration",
      sections: {
        projectApproach: [
          "Retain the existing MTS React website and integrate the new e-commerce experience into the current platform.",
          "Use Shopify as the commerce engine for product management, inventory, customer accounts, orders, payments, checkout, and fulfilment workflows.",
          "Create a dedicated online shop for bathroom products, tapware, replacement parts, accessories, and related product categories.",
          "Configure an initial catalogue of up to 150 products, with the platform structured to support several hundred products and additional suppliers.",
          "Support products fulfilled directly by MTS and products fulfilled through supplier or drop-shipping arrangements.",
          "Create SEO-friendly product categories, product URLs, metadata, structured content, and Google-friendly catalogue architecture.",
          "Configure Google Merchant Centre and the required product feeds for Shopping and Performance Max advertising.",
          "Configure GA4, Google Search Console, e-commerce tracking, conversion measurement, and advertising attribution.",
          "Create the initial Google Ads account structure and e-commerce advertising campaigns.",
          "Provide testing, launch support, platform guidance, and knowledge transfer."
        ],

        oneOff: [
          {
            item: "Discovery, Planning & Solution Design",
            cost: 550
          },
          {
            item: "React Frontend Enhancements & Shop UI Updates",
            cost: 1500
          },
          {
            item: "Shopify Commerce Engine Integration",
            cost: 2000
          },
          {
            item: "Shopify Commerce Platform Configuration",
            cost: 1000
          },
          {
            item: "SEO Category Architecture & GEO Optimisation",
            cost: 1500,
            suffix: "+"
          },
          {
            item: "Catalogue Creation & Optimisation – Up to 150 Products",
            cost: 3500
          },
          {
            item: "Payment Gateway, Shipping, Tax & Fulfilment Configuration",
            cost: 1500
          },
          {
            item: "Customer Accounts & Checkout",
            cost: 0,
            displayCost: "Included"
          },
          {
            item: "Google Merchant Centre & Shopping Feed Configuration",
            cost: 750
          },
          {
            item: "Analytics, Conversion Tracking & Sales Measurement",
            cost: 700
          },
          {
            item: "Google Ads Account Structure & E-Commerce Campaign Build",
            cost: 1750,
            suffix: "+"
          },
          {
            item: "Testing, Launch & Knowledge Transfer",
            cost: 1000
          },
          {
            item: "First-Year Hosting, Security, Monitoring & DNS Management",
            cost: 0,
            displayCost: "Already covered"
          }
        ],

 recurring: [
  {
    item: "Shopify Platform Subscription, paid directly to Shopify – estimated from $56/month",
    costMonthly: 65,
    costYearly: 0,
    thirdParty: true
  },
  {
    item: "2merative Google Ads Campaign Management & Optimisation",
    costMonthly: 1250,
    costYearly: 0
  },
  {
    item: "Monthly Performance Review & Recommendations",
    costMonthly: 0,
    costYearly: 0
  },
  {
    item: "Website & Shopify Platform Maintenance",
    costMonthly: 150,
    costYearly: 0
  },
  {
    item: "Software & Security Updates",
    costMonthly: 0,
    costYearly: 0
  },
  {
    item: "Minor Website & Product Updates – Up to 1 Hour Per Month",
    costMonthly: 0,
    costYearly: 0
  },
  {
    item: "Hosting, Domain, Security, Monitoring & DNS Management – From Year 2 - September 2026",
    costMonthly: 0,
    costYearly: 320
  }
]
      }
    },

    {
      id: "custom-cabinetry-mvp",
      label: "Custom Cabinetry Option 1 – Interactive (recommended)",
      sections: {
        projectApproach: [
          "Create a dedicated Custom Cabinetry section within the existing MTS React website.",
          "Give the cabinetry service its own visual identity, navigation, landing pages, and customer journey while retaining the existing MTS domain and website authority.",
          "Create brochure-style content explaining cabinet ranges, available materials, finishes, colours, benchtops, hardware, service areas, design process, and installation approach.",
          "Create dedicated cabinetry landing pages for organic search and Google Ads campaigns.",
          "Develop a simplified interactive room-planning experience that allows customers to enter their room dimensions.",
          "Allow customers to add, position, resize, and configure supported cabinet types within a simplified room layout.",
          "Provide representative two-dimensional or lightweight three-dimensional cabinet visuals depending on the final agreed interface.",
          "Allow customers to select available cabinet sizes, materials, finishes, colours, benchtops, handles, and other supported options.",
          "Provide an indicative price range based on selected cabinets, measurements, finishes, and configuration rules.",
          "Clearly identify pricing as an initial estimate rather than a final quotation.",
          "Allow customers to submit their room details, cabinet selections, estimated price, contact information, and design requirements to MTS.",
          "Create a strong call to action for the customer to book or request a consultation with an MTS design specialist.",
          "Configure separate cabinetry conversions, analytics, landing pages, and Google Ads campaigns within the existing Google Ads account.",
          "Provide testing, launch support, administration guidance, and knowledge transfer.",
          "Purchase and configure specific domain names"
        ],

        oneOff: [
          {
            item: "Cabinetry Discovery, Requirements & Solution Planning",
            cost: 2000
          },
          {
            item: "Cabinetry UX, Customer Journey & Interface Design",
            cost: 2000
          },
          {
            item: "Dedicated Cabinetry React Website Section",
            cost: 4500
          },
          {
            item: "Cabinet Ranges, Materials, Finishes & Service Content Structure",
            cost: 1500
          },
          {
            item: "Cabinetry SEO, GEO & Landing Page Architecture",
            cost: 2000
          },
          {
            item: "Interactive Room Dimension & Layout Tool",
            cost: 5000
          },
          {
            item: "Configurable Cabinet Library & Placement Controls",
            cost: 4000
          },
          {
            item: "Indicative Cabinetry Pricing Calculator",
            cost: 2500
          },
          {
            item: "Design Submission, Enquiry & Lead Workflow",
            cost: 1500
          },
          {
            item: "Representative Rotating Cabinet Visuals",
            cost: 1500
          },
          {
            item: "GA4, Lead Conversion & Interaction Tracking",
            cost: 750
          },
          {
            item: "Cabinetry Google Ads Campaign Build",
            cost: 1250
          },
          {
            item: "Testing, Launch & Knowledge Transfer",
            cost: 1000
          },
           {
            item: "Configure Domain Names",
            cost: 0
          }
        ],

   recurring: [
  {
    item: "Combined Google Ads Management – E-Commerce & Cabinetry",
    costMonthly: 1850,
    costYearly: 0
  },
  {
    item: "Monthly E-Commerce & Cabinetry Performance Review",
    costMonthly: 150,
    costYearly: 0
  },
  {
    item: "Cabinetry Platform Maintenance",
    costMonthly: 0,
    costYearly: 0
  },
  {
    item: "Software & Security Updates",
    costMonthly: 0,
    costYearly: 0
  },
  {
    item: "Minor Website, Product & Cabinetry Content Updates – Up to 1 Hour Per Month",
    costMonthly: 0,
    costYearly: 0
  }
]
      }
    },

    {
      id: "custom-cabinetry-premium",
      label: "Custom Cabinetry Option 2 – Premium IKEA-Style Planner",
      sections: {
        projectApproach: [
          "Create a premium Custom Cabinetry digital experience within the existing MTS React website.",
          "Provide all brochure, content, SEO, GEO, analytics, advertising, lead-generation, and customer journey features included within the Custom Cabinetry MVP.",
          "Develop a more advanced interactive three-dimensional room planner inspired by established cabinetry and furniture-planning platforms.",
          "Allow customers to enter accurate room dimensions and create a virtual representation of the available room.",
          "Allow walls, doors, windows, room openings, and supported structural features to be added and positioned.",
          "Allow supported cabinets to be added, moved, rotated, resized, removed, and snapped into appropriate positions.",
          "Provide configurable cabinet sizes, layouts, materials, finishes, colours, handles, benchtops, splashbacks, and supported accessories.",
          "Provide realistic or representative three-dimensional cabinet models that customers can rotate and inspect.",
          "Apply cabinet placement rules, dimensional restrictions, collision controls, and compatible product rules where technically practical.",
          "Calculate indicative pricing dynamically from cabinet selections, measurements, materials, finishes, hardware, accessories, and agreed pricing rules.",
          "Allow customers to save and revisit a design using an account, secure design link, or other agreed workflow.",
          "Generate a customer-facing design summary containing room measurements, selected products, indicative pricing, and rendered design images.",
          "Provide MTS with the submitted design, customer information, configuration selections, and supporting design information.",
          "Create a design-specialist workflow so submitted designs can be reviewed, refined, and converted into formal quotations.",
          "Configure independent cabinetry campaigns, conversions, remarketing audiences, and reporting within the existing Google Ads account.",
          "Provide testing, launch support, platform documentation, and staff knowledge transfer."
        ],

        oneOff: [
          {
            item: "Premium Cabinetry Discovery, Requirements & Technical Architecture",
            cost: 4500
          },
          {
            item: "Customer Journey, Planner UX & Interface Design",
            cost: 3000
          },
          {
            item: "Premium Cabinetry React Website Section",
            cost: 6500
          },
          {
            item: "Cabinet Ranges, Materials, Finishes & Service Content Structure",
            cost: 2000
          },
          {
            item: "Advanced Cabinetry SEO, GEO & Landing Page Architecture",
            cost: 2500
          },
          {
            item: "Interactive 3D Room Builder",
            cost: 10000
          },
          {
            item: "Walls, Doors, Windows & Room Configuration Controls",
            cost: 4000
          },
          {
            item: "3D Cabinet Library, Rotation, Placement & Snapping",
            cost: 9000
          },
          {
            item: "Cabinet Configuration, Materials, Finishes & Hardware Controls",
            cost: 4500
          },
          {
            item: "Advanced Dynamic Pricing Engine",
            cost: 4500
          },
          {
            item: "Design Saving & Customer Return Workflow",
            cost: 2500
          },
          {
            item: "Design Summary & PDF Generation",
            cost: 2000
          },
          {
            item: "Design Submission, CRM & Sales Workflow Integration",
            cost: 2500
          },
          {
            item: "GA4, Planner Interaction & Lead Conversion Tracking",
            cost: 1000
          },
          {
            item: "Cabinetry Google Ads Campaign Build",
            cost: 1250
          },
          {
            item: "Testing, Launch & Knowledge Transfer",
            cost: 2000
          }
        ],

      recurring: [
  {
    item: "Combined Google Ads Management – E-Commerce & Cabinetry",
    costMonthly: 1850,
    costYearly: 0
  },
  {
    item: "Premium Cabinetry Planner Maintenance",
    costMonthly: 450,
    costYearly: 0
  },
  {
    item: "Monthly E-Commerce & Cabinetry Performance Review",
    costMonthly: 150,
    costYearly: 0
  },
  
  {
    item: "Software & Security Updates",
    costMonthly: 0,
    costYearly: 0
  },
  {
    item: "Minor Website, Product & Cabinetry Content Updates – Up to 1 Hour Per Month",
    costMonthly: 0,
    costYearly: 0
  }
]
      }
    }
  ],

  gstRate: 0,

  totals: {
  ecommerceBuildSubtotal: 15750,
  cabinetryMvpBuildSubtotal: 29500,
  cabinetryPremiumBuildSubtotal: 61750,

  ecommerceGoogleAdsManagementMonthly: 1250,
  combinedGoogleAdsManagementMonthly: 1850,
  premiumPlannerMaintenanceMonthly: 450,

  ecommercePlusMvpSubtotal: 45250,
  ecommercePlusPremiumSubtotal: 77500
},

  notes: [
    "The MTS e-commerce platform and Custom Cabinetry platform are separate project areas and may be approved, scheduled, and invoiced separately.",
    "The existing MTS React website will remain in place.",
    "The proposed e-commerce shop and Custom Cabinetry experience will be incorporated into the existing website unless otherwise agreed.",
    "Up to four dedicated marketing domain names, such as customcabinetsadelaide.com.au, will be registered where available, configured and redirected to the Custom Cabinetry section of the MTS website. These domains may be used for brand protection, printed materials, signage and other direct marketing activities while maintaining the SEO authority and customer experience of the primary MTS website. Google Ads will direct customers to landing pages hosted on the primary MTS domain.",
    "Initial registration and configuration of up to four standard-price .com.au domain names are included. Premium domain names, previously registered domains, acquisition costs and annual renewal fees are not included unless specifically agreed.",
    "Keeping both services on the existing MTS domain allows the new areas to benefit from the website's existing traffic, domain authority, brand recognition, analytics history, and search performance.",
    
    "The e-commerce project includes an initial catalogue of up to 150 products.",
    "The final number of categories, product variants, supplier feeds, fulfilment arrangements, shipping rules, and drop-shipping processes must be confirmed during discovery.",
    "Product data, supplier information, wholesale pricing, retail pricing, descriptions, specifications, images, delivery details, warranty information, and stock information are to be supplied by MTS or the relevant suppliers.",
    "Automated supplier catalogue, inventory, order, pricing, shipping, or fulfilment integrations are not included unless specifically listed and may require additional quotation.",
    "Additional product creation and optimisation beyond the included catalogue allowance is charged at $25 per product.",
    "Bulk catalogue work involving 250 or more products will be separately assessed and quoted.",
    "Shopify subscription fees are paid directly by MTS.",
    "Shopify application fees, premium themes, premium plugins, supplier applications, product-feed services, inventory applications, shipping applications, or other third-party software costs are not included unless specifically listed.",
    "Payment gateway and transaction fees are charged directly by Shopify, Stripe, PayPal, or the selected payment provider.",
    "The recommended initial Google Ads media budget remains $2,000–$5,000 per month and is paid directly by MTS to Google.",
    "The appropriate advertising budget should be reviewed once the e-commerce and cabinetry campaign objectives, margins, target locations, and expected customer values have been confirmed.",
    "The e-commerce shop and cabinetry service will operate within one Google Ads account.",
    "Separate campaign groups, budgets, search terms, audiences, advertisements, landing pages, conversion actions, and reporting will be configured for the e-commerce and cabinetry services.",
    "The Google Ads campaign setup amounts cover the initial account structure and campaign builds. Ongoing campaign management is charged monthly.",
    "The $1,250 monthly Google Ads management fee applies while only the e-commerce campaigns are active.",
    "The combined $1,850 monthly Google Ads management fee applies once both the e-commerce and cabinetry campaign groups are active.",
    "Google Merchant Centre and Shopping feeds apply to eligible e-commerce products. Custom cabinetry lead-generation campaigns will generally use Search, Performance Max, display remarketing, and other suitable campaign types rather than a standard retail product feed.",
    "The Cabinetry MVP is intended as an interactive lead-generation and indicative pricing tool. It is not intended to produce final manufacturing drawings, engineering specifications, installation drawings, or binding quotations.",
    "The Premium Cabinetry Planner is intended to provide an advanced customer visualisation and sales-enablement experience. It is not represented as an exact replica of the IKEA planner or any other proprietary platform.",
    "The term IKEA-style describes the intended category and level of customer experience only.",
    "Final planner capabilities will depend on the cabinet product rules, available dimensions, finishes, pricing data, three-dimensional assets, supplier information, and technical constraints confirmed during discovery.",
    "All cabinetry pricing shown to customers will be clearly identified as indicative and subject to measurement, design review, product availability, installation requirements, site conditions, delivery costs, and formal quotation.",
    "The pricing engine will rely on pricing data, formulas, margins, product rules, installation allowances, and other information supplied or approved by MTS.",
    "Three-dimensional cabinet models are based on an agreed initial model library.",
    "Custom photorealistic modelling of every cabinet, finish, handle, appliance, room feature, accessory, or product is not included unless specifically listed.",
    "Where suitable supplier-provided 3D models are available, these may reduce modelling effort and improve visual accuracy.",
    "Specialist 3D modelling, product rendering, scanning, photography, video production, architectural drafting, engineering, and interior design services may require specialist third-party suppliers and separate costs.",
    "The Premium Cabinetry Planner includes an initial agreed range of cabinet types and configuration rules. Significant expansion of the model library or product-rule system will be separately assessed.",
    "Customer design saving may use customer accounts, secure links, browser storage, database records, or another suitable method selected during technical design.",
    "CRM integration is based on the available capabilities of the selected CRM or lead-management platform.",
    "CRM subscriptions, automation platform costs, email marketing costs, SMS charges, booking-system costs, and third-party API fees remain the responsibility of MTS.",
    "Final website copy, product information, cabinet specifications, project photographs, videos, testimonials, warranties, service details, and supporting content are to be supplied or approved by MTS.",
    "Copywriting, photography, videography, product rendering, and significant content production are outside the proposal unless separately agreed.",
    "The proposal includes responsive browser-based experiences for supported modern desktop, tablet, and mobile devices.",
    "The full cabinetry planning experience may be simplified on smaller mobile screens where necessary to maintain usability and performance.",
    "The project will be delivered in agreed stages with milestone reviews and approvals.",
    "Changes requested after an agreed design, feature, pricing rule, product structure, or technical milestone has been approved may be treated as additional scope.",
    "Additional website development, product management, catalogue support, integrations, training, or consultancy is charged at $150 per hour unless separately quoted.",
    "Annual hosting, domain registration, security monitoring, and DNS management renew from Year 2 will increase to $320 per year from September 2026.",
    "Third-party pricing may change. Any material supplier cost changes will be communicated before renewal or commitment.",
    "The final project schedule will be confirmed after requirements, content readiness, supplier data, technical dependencies, and the selected cabinetry option have been agreed."
  ],

  acceptance: {
    validUntil: "2026-08-14",
    paymentTerms:
      "Projects will be invoiced separately. A 50% deposit is required to commence. The remaining 50% is due 1 week prior to production launch."
  }
};

export { quoteData };
export default quoteData;